export default __webpack_public_path__ + "static/media/after_2_implants.7a72ee26.png";